import {
  endOfDay,
  isValid,
  parseISO,
  startOfDay,
} from 'date-fns'

// Filter matching shared by the data tables (Device Management, Test Bench, Tickets). Dates
// are exchanged as 'YYYY-MM-DD' strings, the format Mantine's date pickers produce.

export const parseTableDate = (value: string | null): Date | null => {
  if (!value) return null

  const date = parseISO(value)
  return isValid(date) ? date : null
}

const DATE_PARAM_PATTERN = /^\d{4}-\d{2}-\d{2}$/

// The picker, the URL, and matchesDateRange all speak 'YYYY-MM-DD', so the parameter is
// returned unchanged rather than converted. Round-tripping it through a Date is what shifted
// the day for users west of UTC. The pattern test rejects a hand-edited parameter before it
// reaches the picker, and parseISO rejects a well-shaped but impossible date like 2026-02-31.
export const readDateParam = (value: string | null): string | null => {
  if (!value || !DATE_PARAM_PATTERN.test(value)) return null

  return isValid(parseISO(value)) ? value : null
}

export const includesText = (value: string | number | undefined, query: string | null) => {
  if (!query) return true
  return String(value ?? '').toLowerCase().includes(query.trim().toLowerCase())
}

// Bounds are parsed with parseISO, which reads a bare 'YYYY-MM-DD' as local midnight.
// `new Date('YYYY-MM-DD')` and date-fns' startOfDay('YYYY-MM-DD') read it as UTC midnight,
// which moves the range back a day for anyone west of UTC.
export const matchesDateRange = (
  value: Date | number | string | undefined,
  fromValue: string | null,
  toValue: string | null,
) => {
  if (!fromValue && !toValue) return true
  if (value === undefined || value === null || value === '') return false

  const date = value instanceof Date ? value : new Date(value)
  if (!isValid(date)) return false

  const from = parseTableDate(fromValue)
  const to = parseTableDate(toValue)

  if (from && date < startOfDay(from)) return false
  if (to && date > endOfDay(to)) return false

  return true
}
